import {getPrivateAxios} from '../../libs';
import {User} from './types';

/**
 *
 * @returns
 */
export const fetchUserSelf = async () => {
  const {data} = await getPrivateAxios().get<User>('/users/self');
  return data;
};
